<template lang="pug">
v-dialog(
    v-model="show",
    scrollable,
    max-width="600px",
    persistent,
    v-if="categoria"
)
    v-card.Poppins(style="border-radius:10px;")
        v-card-title
            div
                .titulo {{ itemUnico ? 'Mover item' : 'Mover itens' }}
                .body-1(style="color:rgba(17, 19, 18, 0.80);") Categoria atual: {{ categoria.nome }}
        v-divider
        v-card-text(style="max-height: 60vh;")
            .subheading.mb-3(v-if="itemUnico") Item: #[b {{ itemUnico.nome }}]

            v-select(
                v-model="categoriaDestinoId",
                :items="opcoesDestino",
                label="Categoria de destino",
                placeholder="Selecione a categoria",
                outline,
                hide-details,
                :disabled="loading"
            )

            template(v-if="!itemUnico")
                .text-xs-center.py-4(v-if="carregando")
                    v-progress-circular(indeterminate, color="primary", size="24")
                template(v-else)
                    v-text-field.mt-3(
                        v-model="busca",
                        label="Buscar item",
                        prepend-inner-icon="search",
                        clearable,
                        hide-details
                    )
                    .d-flex.align-center.mt-3.mb-1
                        .body-2 Itens
                        v-spacer
                        v-btn.Capitalize.ma-0(
                            flat,
                            small,
                            color="primary",
                            :disabled="!itensMoviveis.length || loading",
                            @click="toggleSelecionarTodos()"
                        ) {{ todosSelecionados ? 'Desmarcar todos' : 'Selecionar todos' }}
                    v-list(style="padding: 0px")
                        v-list-tile.mt-1(
                            v-for="item in itensFiltrados",
                            :key="item.id",
                            style="background-color: rgba(199, 199, 199, 0.3); border-radius:5px;",
                            @click="toggleItem(item)"
                        )
                            v-list-tile-action
                                v-icon(
                                    :color="isSelecionado(item) ? 'primary' : ''",
                                    :style="{ opacity: isPromocaoEspecial(item) ? 0.3 : 1 }"
                                ) {{ isSelecionado(item) ? 'check_box' : 'check_box_outline_blank' }}
                            v-list-tile-content
                                v-list-tile-title.body-1(:style="{ opacity: isPromocaoEspecial(item) ? 0.5 : 1 }") {{ item.nome }}
                                v-list-tile-sub-title.caption.red--text(v-if="isPromocaoEspecial(item)") PROMOÇÃO ESPECIAL - NÃO PODE SER MOVIDO
                                v-list-tile-sub-title.caption.red--text(v-else-if="!(item.ativo && item.disponivel)") INDISPONÍVEL
                    .text-xs-center.grey--text.py-3(v-if="!itensFiltrados.length") Nenhum item encontrado.
        v-divider
        v-card-actions
            v-spacer
            v-btn(
                type="button",
                flat,
                color="gray darken-1",
                :disabled="loading",
                @click="close()"
            ) Fechar
            v-btn.btnMover(
                depressed,
                color="primary",
                :loading="loading",
                :disabled="loading || carregando || !itensSelecionados.length || !categoriaDestinoId",
                @click="mover()"
            ) {{ textoBotaoMover }}
</template>

<script>
import _ from "lodash";

export default {
    data: () => ({
        show: false,
        loading: false,
        carregando: false,
        categoria: null,
        categorias: [],
        carregarItensCategoria: null,
        itens: [],
        itemUnico: null,
        selecionados: [],
        categoriaDestinoId: null,
        busca: "",
    }),
    computed: {
        destinos() {
            return _.orderBy(
                this.categorias.filter(categoria => this.isDestinoValido(categoria, this.categoria)),
                "indice"
            );
        },
        opcoesDestino() {
            return this.destinos.map(categoria => ({
                text: categoria.ativo ? categoria.nome : `${categoria.nome} (indisponível)`,
                value: categoria.id,
            }));
        },
        categoriaDestino() {
            return _.find(this.destinos, { id: this.categoriaDestinoId }) || null;
        },
        itensMoviveis() {
            return this.itens.filter(item => !this.isPromocaoEspecial(item));
        },
        itensSelecionados() {
            return this.itens.filter(item => this.isSelecionado(item));
        },
        itensFiltrados() {
            const termo = this.normalizar(this.busca);
            const itens = _.orderBy(this.itens, "indice");

            if (!termo) {
                return itens;
            }

            return itens.filter(item => this.normalizar(item.nome).includes(termo));
        },
        todosSelecionados() {
            return this.itensMoviveis.length > 0 && this.itensSelecionados.length == this.itensMoviveis.length;
        },
        textoBotaoMover() {
            const total = this.itensSelecionados.length;

            return total ? `Mover ${total} ${total == 1 ? "item" : "itens"}` : "Mover itens";
        },
    },
    methods: {
        async open({ categoria, categorias, carregarItensCategoria, item = null }) {
            if (!categorias.some(atual => this.isDestinoValido(atual, categoria))) {
                return window.getApp.$emit("APP_ALERT", {
                    color: "orange",
                    text: "Não há outras categorias para onde mover.",
                });
            }

            this.categoria = categoria;
            this.categorias = categorias;
            this.carregarItensCategoria = carregarItensCategoria;
            this.itemUnico = item;
            this.itens = item ? [item] : [];
            this.selecionados = item ? [item.id] : [];
            this.categoriaDestinoId = null;
            this.busca = "";
            this.show = true;

            if (item) {
                return;
            }

            this.carregando = true;
            try {
                this.itens = await this.carregarItensCategoria(categoria);
            } finally {
                this.carregando = false;
            }

            if (!this.show) {
                return;
            }

            if (!this.itens.length) {
                window.getApp.$emit("APP_ALERT", {
                    color: "orange",
                    text: "Esta categoria não possui itens.",
                });
                this.close();
            }
        },
        close() {
            this.show = false;
            this.categoria = null;
            this.categorias = [];
            this.itens = [];
            this.itemUnico = null;
            this.selecionados = [];
            this.categoriaDestinoId = null;
            this.busca = "";
        },
        normalizar(texto) {
            return String(texto || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
        },
        isDestinoValido(destino, origem) {
            return destino.id != origem.id && destino.campanha != 1;
        },
        isPromocaoEspecial(item) {
            return !!(item.promocional && item.especial);
        },
        isSelecionado(item) {
            return this.selecionados.includes(item.id);
        },
        toggleItem(item) {
            if (this.loading) {
                return;
            }

            if (this.isPromocaoEspecial(item)) {
                return window.getApp.$emit("APP_ALERT", {
                    color: "orange",
                    text: "Não é possível mover itens de promoção especial.",
                });
            }

            this.selecionados = this.isSelecionado(item)
                ? this.selecionados.filter(id => id != item.id)
                : this.selecionados.concat(item.id);
        },
        toggleSelecionarTodos() {
            this.selecionados = this.todosSelecionados ? [] : this.itensMoviveis.map(item => item.id);
        },
        async mover() {
            const itensSelecionados = this.itensSelecionados;
            const destino = this.categoriaDestino;

            if (!itensSelecionados.length) {
                return window.getApp.$emit("APP_ALERT", {
                    color: "orange",
                    text: "Selecione ao menos um item para mover.",
                });
            }

            if (!destino) {
                return window.getApp.$emit("APP_ALERT", {
                    color: "orange",
                    text: "Selecione a categoria de destino.",
                });
            }

            const total = itensSelecionados.length;
            const descricao = this.itemUnico ? `<b>${_.escape(this.itemUnico.nome)}</b>` : `${total} ${total == 1 ? "item" : "itens"}`;
            const confirmado = await this.$confirm(
                `Deseja mover ${descricao} para a categoria <b>${_.escape(destino.nome)}</b>?`,
                { title: "Confirmar ação" }
            );

            if (!confirmado) {
                return;
            }

            this.loading = true;
            try {
                const itensDestino = await this.carregarItensCategoria(destino);
                const proximoIndice = (_.max(_.map(itensDestino, "indice")) || 0) + 1;
                const itensMovidos = itensSelecionados.map((item, index) => ({
                    ...item,
                    categoria_id: destino.id,
                    indice: proximoIndice + index,
                }));

                await this.$axios.put("/catalogo/item/indice", { itens: itensMovidos });

                this.$emit("itens-movidos", {
                    itens: itensMovidos,
                    origem: this.categoria,
                    destino,
                });

                window.getApp.$emit("APP_ALERT", {
                    color: "success",
                    text: total == 1 ? "Item movido com sucesso!" : "Itens movidos com sucesso!",
                });

                this.close();
            } catch (error) {
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao mover os itens. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.titulo {
    font-family: "Poppins", "Roboto", "Helvetica" !important;
    font-size: 20px !important;
    font-weight: 500;
    line-height: 1 !important;
    letter-spacing: 0.02em !important;
}
.Poppins {
    font-family: "Poppins", "Roboto", "Helvetica" !important;
}
.Capitalize {
    text-transform: capitalize;
}
.btnMover {
    border-radius: 5px !important;
    color: #fff;
    font-weight: 600;
}
</style>
